import { render, staticRenderFns } from "./ClientsSource.vue?vue&type=template&id=78b44fd0&"
import script from "./ClientsSource.vue?vue&type=script&lang=js&"
export * from "./ClientsSource.vue?vue&type=script&lang=js&"
import style0 from "./ClientsSource.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports